import React, { useState, useEffect, useCallback } from 'react';
import Loader from '@components/common/Loader/newLoaderModal';
import { useNavigate } from 'react-router-dom';
import AppSidebarV2 from '../AppSidebarV2/index';
import MenuContent from '../MenuContent';
import MenuCartBarV2 from '../MenuCartBarV2';
import getDeviceType from '@utility/deviceType';
import { connect } from 'react-redux';
import CondimentsModalV2 from './CondimentsModalV2';
import { finalizeSplit } from '../MenuCartBarV2/CartButtons/CartPaymentHandler';
import {setOrderNavLoading, setCartUpdateLoading, setCartSyncDone } from '@reducers/orders';
import { bindActionCreators } from 'redux';

const ServerAppMenuOrderV2 = ({
  serverAppTheme,
  menuItemsHashTable,
  seat,
  loading,
  cartUpdateLoading,
  cartSyncDone,
  setCartUpdateLoading,
  setCartSyncDone,
}) => {
  const { isCounter , isCallCenter, isDriveThru } = getDeviceType();
  const navigate = useNavigate();
  const [condimentsModal, setCondimentsModal] = useState({ isOpen: false });
  const [driveThruLoader, setDriveThruLoader] = useState(false);
  const [isPayClick, setIsPayClick] = useState(false);

  useEffect(() => {
    if (cartSyncDone) {
      setCartUpdateLoading(false);
      setCartSyncDone(false);
    }
  }, [cartSyncDone]);
  
  useEffect(() => {
    // just for setting the loader as "false" which is set to "true" in checkListing screen
    // file where it was set as "true" - src/containers/StoreChecks/indexCopy.jsx
    setOrderNavLoading(false);
    if (cartUpdateLoading === 'Loading...') {
      setCartUpdateLoading(false);
    }
  }, []);

  useEffect(() => {
    if (isCounter || isCallCenter || isDriveThru) {
      window.counterCondimentsModal = {
        open: () => setCondimentsModal({ isOpen: true }),
        close: () => setCondimentsModal({ isOpen: false }),
        setLoader: (val) => setDriveThruLoader(val),
      };
    }
    return () => {
      delete window.counterCondimentsModal;
    };
  }, [isCounter, isCallCenter, isDriveThru]);

  const handleFinalizeSplit = useCallback(
    ({ data, condimentItems }) => finalizeSplit({ data, condimentItems, navigate }),
    [navigate]
  );

  const handleCloseCondimentModal = useCallback(
    () => setCondimentsModal({ isOpen: false }),
    []
  );

  return (
    <div className={`h-100 px-2 ${(isCounter || isDriveThru) ? 'pt-1 pb-3' : 'py-3'} d-flex flex-column`}>
      <div className="d-flex flex-1" style={{ minHeight: 0 }}>
        <AppSidebarV2 />
        <MenuContent />
        <MenuCartBarV2 />
      </div>
      {(isCounter || isCallCenter || isDriveThru) && condimentsModal?.isOpen && (
        <CondimentsModalV2
          isOpen={condimentsModal.isOpen}
          serverAppTheme={serverAppTheme}
          menuItemsHashTable={menuItemsHashTable}
          closeCondimentModal={handleCloseCondimentModal}
          seat={seat}
          driveThruLoader={driveThruLoader}
          finalizeSplit={handleFinalizeSplit}
          setIsPayClick={setIsPayClick}
          isPayClick={isPayClick}
          loading={loading}
        />
      )}
   {(loading || cartUpdateLoading) && (
  <Loader
    message={
      typeof cartUpdateLoading === 'string'
        ? cartUpdateLoading
        : 'Please wait while we are updating your cart with your changes.'
    }
  />
)}
    </div>
  );
};

const mapStateToProps = ({ theme, orders, notification, storeChecks }) => ({
  serverAppTheme: theme.serverAppTheme,
  menuItemsHashTable: orders.menuItemsHashTable,
  seat: orders.seats,
  loading: notification.loading || storeChecks.loading,
  cartUpdateLoading: orders.cartUpdateLoading,
  cartSyncDone: orders.cartSyncDone,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  setCartUpdateLoading,
  setCartSyncDone,
   setOrderNavLoading
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(ServerAppMenuOrderV2));
